export default __webpack_public_path__ + "d1b818587c3bc65058fe43800e4a191c.png";